import { Container, Row, Col } from "react-bootstrap";
import LoginForm from "../components/LoginForm";

export function LoginPage() {

    return (
        <Container fluid className=" vh-100 d-flex align-items-center justify-content-center">
            <Row className="w-100 justify-content-center">
                <Col xs={12} sm={8} md={6} lg={4} className="d-flex flex-column align-items-center">

                    {/* Title */}
                    <h1 className="display-1 ff_shooting_star mb-5">Login</h1>

                    <LoginForm />

                    {/* Form Container */}

                </Col>
            </Row>
        </Container>

    )
    return (
        <Container fluid className='ff_repunzel vh-100' >
            <Row className="justify-content-md-center my-3">
                <Col xs='auto'>
                    <h1 className=" display-1 ff_shooting_star">Login Page</h1>
                </Col>
                <div>
                    <h1>Login Page</h1>
                    <LoginForm />
                </div>
            </Row>

        </Container>
    )
}